module.exports = __webpack_public_path__ + "static/media/avatar5.150165d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar5.png
// module id = 39
// module chunks = 0